import React from "react";
import { componentStyles } from "./tag.scss";
import PictureComponent from "/components/core/picture/picture-component";
import { trackEvent } from "/services/bigbrain-service";
import { GRID_TAG_CLICKED } from "/constants/bigbrain-event-types";

import DefaultProps from "./default-props";

const Tag = (props) => {
  const { tagIconsrc, tagText, onClick } = props;

  const onTagClick = () => {
    trackEvent(GRID_TAG_CLICKED, { kind: tagText });
    if (onClick) {
      onClick(tagText);
    }
  };

  return (
    <div className="tag" onClick={onTagClick}>
      <div className="tag-image-wrapper">
        <PictureComponent className="tag-icon" pictureClass="tag-picture" src={tagIconsrc} />
      </div>
      <div className="tag-text">{tagText}</div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default Tag;

Tag.defaultProps = DefaultProps;
